import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Util from 'root/module/util';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Svg_Icon from 'root/module/svg_icon';
import Modals from 'root/modals';
import View from 'view/base';
import View_Dev_Tools from 'view/dev_tools';
import { loadCustomData } from 'service/session_recording';

import rrwebPlayer from 'rrweb-player';
import {getRecordConsolePlugin} from 'rrweb';

var Session_Player = View.extend({
    className: 'session-player pending', // devtool-open console-open

    views: {
        devtools: {},
    },

    skip_inactive: true,
    speed: 1, // 1, 2, 4, 8

    start_time : null,
    end_time   : null,
    total_time : null,

    current_time : null,

    rrweb_nodes: {},
    rrweb_events: {},

    rrweb_inactivities: [],

    auto_load: false,
    show_dev_tools: true,
    show_events: true,
    show_close: false,
    show_mouse_tail: true,

    is_paused: true,

    devtool_menu_type: 'console', //console, network
    log_menu_type: 'all',

    event_types_on: ['click', 'focus', 'input', 'resize', 'navigation', 'browser_tab', 'feedback', 'custom', 'rage_click'],

    devtools_height: 240,

    session_tags : null,

    session_poll_request: null,
    session_poll_timeout: null,
    session_abort_controller: null,

    events: {
        'click .region-player'                   : 'onPlayOrPause',
        'click .media-control-play'              : 'onPlay',
        'click .media-control-pause'             : 'onPause',
        'click .media-control-replay'            : 'onReplay',
        'click .media-control-speed'             : 'onChangeSpeed',
        'click .region-devtools-toggle'          : 'onToggleDevtools',
        'click .region-events-toggle'            : 'onToggleDevtool',
        'click .devtools-close'                  : 'onCloseConsole',
        'click .skip-inactivity'                 : 'onSkipInactivity',
        'click .media-control-fullscreen'        : 'onToggleFullscreen',
        'click .region-timeline'                 : 'onClickTimeline',
        'click .play-tag'                        : 'onClickTag',
        'click .event-item'                      : 'onClickEvent',
        'click .code-copy'                       : 'onCopyElement',
        'click .tag-toggle'                      : 'onToggleTag',
        'click .mouse-tail-toggle'               : 'onToggleMouseTail',
        'click .json-expand'                     : 'onExpandJson',
        'click .log-message[data-type="string"]' : 'onExpandLogMessage',
        'click .log-item .goto'                  : 'onGotoConsoleLogo',
        'click .devtools-menu'                   : 'onClickDevtoolMenu',
        'click .log-menu'                        : 'onClickLogMenu',
        'click .replay-close'                    : 'onClickClose',
        'click .replay-share'                    : 'onShareReplay',
        'click .replay-tag'                      : 'onEditTag',
    },

    dom_handlers: {
        onPlay: function(e) {
            this.rrwebPlayer.play();
        },

        onPause: function(e) {
            this.rrwebPlayer.pause();
        },

        onPlayOrPause: function(e) {
            if (!this.rrwebPlayer) {
                return;
            }

            var indicator = $('<div>').addClass('indicator');

            if (this.is_paused) {
                this.rrwebPlayer.play();
                indicator.html(Svg_Icon.media_play);
            } else {
                this.rrwebPlayer.pause();
                indicator.html(Svg_Icon.media_pause);
            }

            indicator.appendTo(this.$el.find('.region-player'));

            setTimeout(function() {
                indicator.remove();
            }, 700);
        },

        onReplay: function(e) {
            this.rrwebPlayer.play(0);
        },

        onToggleDevtool: function(e) {
            this.$el.toggleClass('devtool-open');

            this.setPlayerSize();
        },

        onToggleDevtools: function(e) {
            if (this.$el.hasClass('devtools-open')) {
                this.$el.removeClass('devtools-open');

                this.$el.find('.region-player').css('margin-bottom', 0);
            } else {
                this.$el.addClass('devtools-open');

                this.$el.find('.region-player').css('margin-bottom', this.devtools_height);
                this.$el.find('.region-devtools-box').css('height', this.devtools_height);
            }

            this.setPlayerSize();
        },

        onCloseConsole: function(e) {
            this.$el.find('.region-devtools-toggle').click();
        },

        onChangeSpeed: function(e) {
            var options = [1, 2, 4, 8];

            var current_index = options.indexOf(this.speed);
            var new_index     = current_index >= options.length - 1 ? 0 : current_index + 1;

            this.speed = options[new_index];

            this.rrwebPlayer.setSpeed(this.speed);

            this.$el.find('.media-control-speed > span').text(this.speed);

            Cache.app.addUserSetting('session_replay_speed', this.speed, false);
        },

        onSkipInactivity: function(e) {
            this.skip_inactive = !this.skip_inactive;

            if (this.skip_inactive) {
                this.$el.find('.skip-inactivity').removeClass('switch-off').addClass('switch-on');
            } else {
                this.$el.find('.skip-inactivity').removeClass('switch-on').addClass('switch-off');
            }

            this.rrwebPlayer.toggleSkipInactive();

            Cache.app.addUserSetting('session_replay_skip_inactive', this.skip_inactive, false);
        },

        onToggleFullscreen: function(e) {
            if (document.fullscreenElement !== null) {
                document.exitFullscreen();
            } else {
                this.$el.get(0).requestFullscreen();
            }
        },

        onClickTimeline: function(e) {
            if ($(e.target).hasClass('play-tag')) {
                return;
            }

            if ($(e.target).hasClass('play-progress-circle')) {
                return;
            }

            var percent = e.offsetX / this.$el.find('.region-timeline').width();
            var goto = this.total_time * percent;

            this.rrwebPlayer.goto(goto);
        },

        onDragTimeline: function(e, ui) {
            var percent = ui.position.left / this.$el.find('.region-timeline').width();
            var goto = this.total_time * percent;

            this.rrwebPlayer.goto(goto);
        },

        onDragConsoleStart: function(e, ui) {
            ui.helper.data('panel_height', this.$el.find('.region-devtools-box').height());
            ui.helper.data('player_bottom', parseInt(this.$el.find('.region-player').css('margin-bottom'), 10));
        },

        onDragConsoleStop: function(e, ui) {
            // TODO: remember resize result
        },

        onDragConsolePanel: function(e, ui) {
            var top = ui.position.top * -1;

            this.devtools_height = this.$el.find('.region-devtools-box').height() + top;
            this.devtools_height = Math.max(this.devtools_height, 100);
            this.devtools_height = Math.min(this.devtools_height, this.$el.height() * 0.7);

            top = this.devtools_height - ui.helper.data('panel_height');

            this.$el.find('.region-player').css('margin-bottom', ui.helper.data('player_bottom') + top);
            this.$el.find('.region-devtools-box').height(this.devtools_height);

            this.setPlayerSize();
        },

        onClickDevtoolMenu: function(e) {
            this.devtool_menu_type = $(e.currentTarget).data('type');

            this.$el.find('.devtools-menu').removeClass('active');
            $(e.currentTarget).addClass('active');
            this.$el.find('.devtools-content').removeClass('active');
            this.$el.find('.region-' + this.devtool_menu_type).addClass('active');

            this.$el.find('.log-menu').attr('data-type', this.log_menu_type);
        },

        onClickLogMenu: function(e) {
            this.log_menu_type = $(e.currentTarget).data('type');

            this.$el.find('.log-menu').removeClass('active');
            $(e.currentTarget).addClass('active');

            this.$el.find('.console-panel').attr('data-type', this.log_menu_type);
        },

        onGotoConsoleLogo: function(e) {
            this.rrwebPlayer.pause();
            this.rrwebPlayer.goto($(e.currentTarget).data('goto'));
        },

        onClickTag: function(e) {
            this.rrwebPlayer.pause();
            this.rrwebPlayer.goto($(e.currentTarget).data('goto'));
        },

        onClickEvent: function(e) {
            this.rrwebPlayer.pause();
            this.rrwebPlayer.goto($(e.currentTarget).data('goto'));
            $(e.currentTarget).toggleClass('open');
        },

        onCopyElement: function(e) {
            e.stopPropagation();

            var code = $(e.currentTarget).parents('.event-details').find('.code').text();

            Util.copyText(code, function() {
                UI.success('Element copied');
            });
        },

        onToggleMouseTail: function(e) {
            e.stopPropagation();

            this.show_mouse_tail = !this.show_mouse_tail;

            if (this.show_mouse_tail) {
                this.$el.find('.mouse-tail-toggle').addClass('switch-on').removeClass('switch-off');
            } else {
                this.$el.find('.mouse-tail-toggle').addClass('switch-off').removeClass('switch-on');
            }

            this.$el.find('.replayer-mouse-tail').toggle(this.show_mouse_tail);
        },

        onToggleTag: function(e) {
            e.stopPropagation();

            var tag_type = $(e.currentTarget).data('type');

            if ($(e.currentTarget).hasClass('switch-on')) {
                $(e.currentTarget).addClass('switch-off').removeClass('switch-on');
                this.$el.find('.play-tag[data-type="' + tag_type + '"]').hide();
                this.$el.find('.event-item[data-type="' + tag_type + '"]').hide();

                this.event_types_on.splice(this.event_types_on.indexOf(tag_type), 1);
            } else {
                $(e.currentTarget).addClass('switch-on').removeClass('switch-off');
                this.$el.find('.play-tag[data-type="' + tag_type + '"]').show();
                this.$el.find('.event-item[data-type="' + tag_type + '"]').show();

                this.event_types_on.push(tag_type);
            }

            Cache.app.addUserSetting('session_replay_event_types_on', this.event_types_on.join(','), false);
        },

        onExpandJson: function(e) {
            $(e.currentTarget).parents('.log-message:first').toggleClass('expanded');
        },

        onExpandLogMessage: function(e) {
            if ($(e.currentTarget).parents('.log-row:first').data('type') === 'error') {
                // error is always expanded
                return;
            }

            $(e.currentTarget).toggleClass('expanded');
        },

        onWindowResize: function(e) {
            if (!this.rrwebPlayer) {
                return;
            }

            clearTimeout(this.resize_timeout);
            this.resize_timeout = setTimeout(function() {
                this.setPlayerSize();
            }.bind(this), 100);
        },

        onShareReplay: function(e) {
            Modals.shareSessionRecording(this.session_recording_id, {
                start_at: this.current_time
            });
        },

        onEditTag: function(e) {
            var model = Cache.session_recording.get(this.session_recording_id);

            if (model) {
                Modals.editSessionTag(model, this.session_tags);
            }
        },

        onClickClose: function(e) {
            this.pause();
            this.trigger('close');
            this.remove();
        },
    },

    event_handlers: {
        onTagChange: function() {
            this.renderTags();
        },
    },

    player_handlers: {
        onStart: function() {
            this.$el.find('.media-control-play').hide();
            this.$el.find('.media-control-pause').show();
            this.$el.find('.media-control-replay').hide();

            this.is_paused = false;
        },

        onPause: function() {
            this.$el.find('.media-control-play').show();
            this.$el.find('.media-control-pause').hide();
            this.$el.find('.media-control-replay').hide();

            this.is_paused = true;
        },

        onFinish: function() {
            this.$el.find('.media-control-play').hide();
            this.$el.find('.media-control-pause').hide();
            this.$el.find('.media-control-replay').show();
        },

        onResize: function(size) {
            this.$el.find('.region-resolution span').text(size.width + ' x ' + size.height);
        },

        onSkipStart: function() {
            this.$el.find('.skip-inactivity').prop('disabled', true);
        },

        onSkipEnd: function() {
            this.$el.find('.skip-inactivity').prop('disabled', false);
        },

        onEventCast: function(event) {
            if (event.type === Constants.RRWEB_EVENT_TYPE.Meta) {
                this.renderMeta(event);
            }
        },

        onTimeUpdate: function(e) {
            this.current_time = this.getDisplayTime(e.payload / 1000);

            this.$el.find('.video-time-current').text(this.current_time);

            // highlight events
            var goto = Math.floor(e.payload);
            var last_key;

            _.keys(this.rrweb_events).forEach(function(key) {
                if (goto >= key) {
                    last_key = key;
                }
            }.bind(this));

            if (this.show_events && last_key) {
                var event_el       = this.rrweb_events[last_key].event_el;
                var container      = this.$el.find('.region-events');
                var scroll_top     = container.scrollTop();
                var scroll_top_new = event_el.get(0).offsetTop;
                var is_in_viewport = scroll_top_new > scroll_top && scroll_top_new < scroll_top + container.height() * 0.7;

                // event is not turned on
                if (event_el.is(':hidden')) {
                    return;
                }

                // highlight the event
                this.$el.find('.event-item.active').removeClass('active');
                event_el.addClass('active played');

                event_el.prevAll('.event-item').addClass('played');
                event_el.nextAll('.event-item').removeClass('played');

                // scroll to it
                if (!is_in_viewport) {
                    container.scrollTop(scroll_top_new - 100);
                }
            }
        },

        onProgressUpdate: function(e) {
            this.$el.find('.play-progress').css('width', e.payload * 100 + '%');
            this.$el.find('.play-progress-circle').css('left', e.payload * 100 + '%');
        }
    },

    setPlayerSize: function() {
        this.rrwebPlayer.$set({
            width  : this.$el.find('.region-player').width(),
            height : this.$el.find('.region-player').height()
        });
        this.rrwebPlayer.triggerResize();
    },

    initialize: function(options) {
        this.rrweb_nodes        = {};
        this.rrweb_events       = {};
        this.rrweb_inactivities = [];

        this.session_recording_id = options.session_recording_id;

        this.auto_load       = !!options.auto_load;
        this.show_dev_tools  = !!options.show_dev_tools;
        this.show_events     = !!options.show_events;
        this.show_close      = !!options.show_close;
        this.show_share      = !!options.show_share;
        this.show_tag        = !!options.show_tag;
        this.start_at        = parseInt(options.start_at, 10) || 0; // in milliseconds
        this.start_timestamp = parseInt(options.start_timestamp, 10) || null; // in unix timestamp
        this.start_event     = options.start_event || null;
        this.open_devtools = options.open_devtools;

        this.views.devtools = new View_Dev_Tools({
            show_event: false,
        });

        // saved user settings
        var speed = parseInt(Cache.app.getUserSetting('session_replay_speed', false), 10) || 1;
        var skip_inactive = Cache.app.getUserSetting('session_replay_skip_inactive', false);
        var event_types_on = Cache.app.getUserSetting('session_replay_event_types_on', false);

        if ([1, 2, 4, 8].indexOf(speed) !== -1) {
            this.speed = speed;
        }

        if (skip_inactive !== null) {
            this.skip_inactive = !!skip_inactive;
        }

        if (event_types_on !== null) {
            this.event_types_on = event_types_on.split(',');
        }

        var model = Cache.session_recording.get(this.session_recording_id);

        if (model) {
            this.listenTo(model, 'change:tag', this.event_handlers.onTagChange);
        }

        if (this.show_tag) {
            loadCustomData((response) => {
                this.session_tags = response.tags;
            });
        }

        this.on('remove', () => {
            // attempt to cancel in-flight requests
            this.session_poll_request?.abort();
            this.session_poll_timeout ? clearTimeout(this.session_poll_timeout) : null;
            this.session_abort_controller?.abort('closed');
        });
    },

    getDisplayTime: function(seconds, display_length) {
        seconds = Math.floor(seconds);

        var hour = Math.floor(seconds / 3600);
        var min  = Math.floor((seconds - hour * 3600) / 60);
        var sec  = seconds - hour * 3600 - min * 60;

        if (min < 10 && !display_length) {
            min = '0' + min;
        }

        if (sec < 10 && !display_length) {
            sec = '0' + sec;
        }

        if (display_length) {
            return (hour ? hour + ' hour ' : '') + (min ? min + ' min ' : '') + sec + ' seconds';
        } else {
            return (hour ? hour + ':' : '') + min + ':' + sec;
        }
    },

    pause: function() {
        if (this.rrwebPlayer) {
            this.rrwebPlayer.pause();
        }
    },

    resize: function() {
        this.dom_handlers.onWindowResize.call(this);
    },

    updateDuration: function() {
        // do not update when being shared
        if (!Cache.real_user_id) {
            return;
        }

        if (!this.total_time) {
            return;
        }

        var model = Cache.session_recording.get(this.session_recording_id);

        var duration = Math.floor(this.total_time / 1000);

        if (model && model.get('duration') !== duration) {
            Cache.app.request({
                action:  'session_recording/update',
                data: {
                    id: this.session_recording_id,
                    duration: duration
                },
                success: (response) => {
                    model.set('duration', duration);
                }
            });
        }
    },

    load: function() {
        if (this.is_loaded) {
            return;
        }

        var model = Cache.session_recording.get(this.session_recording_id);

        this.pollEvents('', this.session_recording_id);

        if (!model) {
            Cache.app.request({
                action: 'session_recording/search',
                data: {
                    session_recording_id: this.session_recording_id
                },
                success: (response) => {
                    if (response.data && response.data.length) {
                        model = Cache.session_recording.add(response.data[0]);

                        this.listenTo(model, 'change:tag', this.event_handlers.onTagChange);
                        this.renderTags();
                    } else {
                        UI.error('Session replay can\'t be loaded.');
                    }
                }
            });
        }
    },

    pollEvents: function(job_id, session_recording_id) {
        if (session_recording_id != this.session_recording_id) {
            return;
        }
        this.session_poll_request = Cache.app.request({
            action: 'session_recording/pollEvents',
            data: {
                job_id: job_id,
                id: this.session_recording_id,
            },
            success: (response) => {
                if (response === true) {
                    this.loadEvents();
                } else if (response === false) {
                    UI.error('Session replay can\'t be loaded.', response);
                    return;
                } else {
                    this.session_poll_timeout = setTimeout(() => {
                        this.pollEvents(response, session_recording_id);
                    }, 1000);
                }
            }
        });
    },

    loadEvents: function() {
        Cache.app.request({
            action: 'session_recording/getEvents',
            data: {
                id: this.session_recording_id
            },
            success: (event_urls) => {
                var event_requests = [];
                var json_responses = [];
                var error = false;

                this.session_abort_controller = new AbortController();
                const signal = this.session_abort_controller.signal;

                for (const url of event_urls) {
                    event_requests.push(fetch(url, { signal }));
                }

                // Load the json for each of the responses and reassemble them in order
                Promise.all(event_requests).then((responses) => {
                    this.session_abort_controller = null;
                    for (const response of responses) {
                        if (response.ok) {
                            json_responses.push(response.json());
                        } else if (response.status == 404) {
                            // s3 might be slow updating the object list after delete
                        } else {
                            error = true;
                        }
                    }

                    if (error) {
                        UI.error('Session replay can\'t be loaded.');
                        return;
                    }

                    this.events = [];
                    Promise.all(json_responses).then((responses) => {
                        for (const response of responses) {
                            if (!response) {
                                error = true;
                            } else {
                                this.events = this.events.concat(response);
                            }
                        }
                        if (error) {
                            UI.error('Session replay can\'t be loaded.');
                        } else {
                            this.onLoad();
                        }
                    }, () => {
                        UI.error('Session replay can\'t be loaded.');
                    });
                }).catch((error) => {
                    if (error != 'closed') {
                        throw(error);
                    }
                });
            }
        });
    },

    onLoad: function() {
        this.is_loaded = true;

        if (this.events.length < 2) {
            this.$el.find('.region-player').removeClass('loader');
            this.$el.find('.region-player').html('<div class="error-msg">Couldn\'t load session recording.</div>');
            return;
        }

        var insert_styles =
        '.userback-block {' +
            'border: none;' +
            'outline: none;' +
            'box-shadow: none;' +
            'background-color: #FFFFFF;' +
            'box-shadow: 0 0 0 1px #CCCCCC inset;' +
            'background: repeating-linear-gradient( -45deg, #EEEEEE, #EEEEEE 2px, #FFFFFF 2px, #FFFFFF 10px );' +
        '}';

        this.rrwebPlayer = new rrwebPlayer({
            target: this.$el.find('.region-player').get(0),
            props: {
                events           : this.events,
                width            : this.$el.find('.region-player').width(),
                height           : this.$el.find('.region-player').height(),
                autoPlay         : false,
                showController   : false,
                showWarning      : false,
                skipInactive     : this.skip_inactive,
                speed            : this.speed,
                speedOption      : [1, 2, 4, 8],
                insertStyleRules : [insert_styles],
                mouseTail        : this.show_mouse_tail
            },
            plugins: [getRecordConsolePlugin({
                level: ['info', 'log', 'warn']
            })]
        });

        var meta_data = this.rrwebPlayer.getMetaData();

        this.start_time = meta_data.startTime;
        this.end_time   = meta_data.endTime;
        this.total_time = meta_data.totalTime;

        this.updateDuration();

        this.rrwebPlayer.addEventListener('ui-update-current-time', this.player_handlers.onTimeUpdate.bind(this));
        this.rrwebPlayer.addEventListener('ui-update-progress',     this.player_handlers.onProgressUpdate.bind(this));

        this.rrwebPlayer.addEventListener('start',  this.player_handlers.onStart.bind(this));
        this.rrwebPlayer.addEventListener('pause',  this.player_handlers.onPause.bind(this));
        this.rrwebPlayer.addEventListener('finish', this.player_handlers.onFinish.bind(this));
        this.rrwebPlayer.addEventListener('resize', this.player_handlers.onResize.bind(this));

        this.rrwebPlayer.addEventListener('skip-start', this.player_handlers.onSkipStart.bind(this));
        this.rrwebPlayer.addEventListener('skip-end',   this.player_handlers.onSkipEnd.bind(this));

        this.rrwebPlayer.addEventListener('event-cast', this.player_handlers.onEventCast.bind(this));

        $(window).on('resize', this.dom_handlers.onWindowResize.bind(this));

        this.$el.find('.region-player').removeClass('loader');

        // events
        this.readEvents();
        this.highlightInactivity();

        // auto start timestamp
        if (this.start_timestamp) {
            var start_buffer = 1000;
            this.start_at = this.start_timestamp * 1000 - this.start_time - start_buffer;
        }

        // auto start milliseconds
        if (this.start_at > 0 && this.start_at < this.total_time) {
            this.rrwebPlayer.goto(this.start_at);
        }

        // total time
        this.$el.find('.video-time-total').text(this.getDisplayTime(this.total_time / 1000));

        this.$el.find('.play-progress-circle').draggable({
            axis: 'x',
            containment: this.$el.find('.region-timeline'),
            stop: this.dom_handlers.onDragTimeline.bind(this)
        });

        this.$el.find('.drag-handle').draggable({
            axis: 'y',
            helper: 'clone',
            start: this.dom_handlers.onDragConsoleStart.bind(this),
            drag: this.dom_handlers.onDragConsolePanel.bind(this)
        });

        this.$el.removeClass('pending');

        this.$el.find('.media-control-play').prop('disabled', false);
        this.$el.find('.media-control-pause').prop('disabled', false);
        this.$el.find('.media-control-replay').prop('disabled', false);
        this.$el.find('.media-control-speed').prop('disabled', false);
        this.$el.find('.media-control-settings > button').prop('disabled', false);
        this.$el.find('.skip-inactivity').prop('disabled', false);

        if (this.open_devtools) {
            this.$el.find('.region-devtools-toggle').click();
        }
    },

    readNodes: function(nodes, parent_node) {
        nodes[parent_node.id] = parent_node;

        if (typeof parent_node.childNodes !== 'undefined') {
            parent_node.childNodes.forEach((node) => {
                this.readNodes(nodes, node);
            });
        }
    },

    readNode: function(node) {
        this.rrweb_nodes[node.id] = node;

        if (node.childNodes) {
            node.childNodes.forEach((child_node) => {
                this.readNode(child_node);
            });
        }
    },

    getNodeDisplayName: function(node) {
        var selector = '';
        var element = '';

        var attributes = '';

        if (node && node.tagName) {
            if (node.attributes['id']) {
                selector = '#' + node.attributes['id'];
            } else if (node.attributes['class']) {
                selector = '.' + node.attributes['class'];
            } else if (node.attributes['type']) {
                selector = node.attributes['type'];
            } else if (node.tagName) {
                selector = node.tagName;
            }

            _.each(node.attributes, function(value, name) {
                attributes += ' ' + name + '="' + value +  '"';
            });

            element  = node.tagName ? '<' + node.tagName + attributes + ' />' : '';
        }

        return {
            selector : selector,
            element  : element
        };
    },

    // https://github.com/rrweb-io/rrweb/blob/master/packages/rrweb/src/replay/index.ts#L1741
    isUserInteraction:function(event) {
        if (event.type !== Constants.RRWEB_EVENT_TYPE.IncrementalSnapshot) {
            return false;
        }

        return (event.data.source > Constants.RRWEB_INCREMENTAL_SOURCE.Mutation && event.data.source <= Constants.RRWEB_INCREMENTAL_SOURCE.Input);
    },

    readEvents: function() {
        var event_start = this.events.length ? this.events[0].timestamp : 0;

        this.log_total   = 0;
        this.warn_total  = 0;
        this.error_total = 0;
        this.info_total  = 0;

        this.events.forEach((event) => {
            if (event.data.adds && event.data.adds.length) {
                event.data.adds.forEach((add) => {
                    if (add.node) {
                        this.readNode(add.node);
                    }
                });
            }

            if (event.data.node) {
                this.readNode(event.data.node);
            }

            if (event.timestamp - event_start >= Constants.RRWEB_SKIP_TIME_THRESHOLD) {
                this.rrweb_inactivities.push({
                    start : event_start,
                    stop  : event.timestamp
                });
            }

            if (this.isUserInteraction(event)) {
                event_start = event.timestamp;
            }

            if (this.start_event && event.data.payload && event.data.payload.name === this.start_event) {
                this.start_at = event.timestamp - this.start_time;
            }

            switch (event.type) {
                case Constants.RRWEB_EVENT_TYPE.Meta:
                    this.renderMeta(event);

                    break;
                case Constants.RRWEB_EVENT_TYPE.Custom:
                    if (event.data.tag === 'error') {
                        this.addCustomError(event);
                    } else if (event.data.tag === 'navigation') {
                        this.addTag(event, 'navigation', 'Navigation');
                    } else if (event.data.tag === 'browser_tab') {
                        this.addTag(event, 'browser_tab');
                    } else if (event.data.tag === 'feedback') {
                        this.addTag(event, 'feedback');
                    } else if (event.data.tag === 'rage_click') {
                        this.addTag(event, 'rage_click', 'Rage Click');
                    } else if (event.data.payload && event.data.payload.name) {
                        this.addTag(event, 'custom', event.data.payload.name);
                    } else {
                        this.addTag(event, 'custom');
                    }
                    break;
                case Constants.RRWEB_EVENT_TYPE.IncrementalSnapshot:
                    if (event.data.source === Constants.RRWEB_INCREMENTAL_SOURCE.MouseInteraction) {
                        if (event.data.type === Constants.RRWEB_MOUSE_INTERACTIONS.Click) {
                            this.addTag(event, 'click', 'Mouse Click');
                        } else if (event.data.type === Constants.RRWEB_MOUSE_INTERACTIONS.Focus) {
                            this.addTag(event, 'focus', 'Focus');
                        }
                    } else if (event.data.source === Constants.RRWEB_INCREMENTAL_SOURCE.Input) {
                        this.addTag(event, 'input', 'Text Input');
                    } else if (event.data.source === Constants.RRWEB_INCREMENTAL_SOURCE.ViewportResize) {
                        this.addTag(event, 'resize', 'Window Resize');
                    }

                    break;
            }
        });

        this.addConsoleLog();
        this.addNetworkLog();

        this.$el.find('.log-menu[data-type="log"] .log-total').text(this.log_total);
        this.$el.find('.log-menu[data-type="warn"] .log-total').text(this.warn_total);
        this.$el.find('.log-menu[data-type="error"] .log-total').text(this.error_total);
        this.$el.find('.log-menu[data-type="info"] .log-total').text(this.info_total);
        this.$el.find('.log-menu[data-type="all"] .log-total').text((this.log_total + this.warn_total + this.error_total + this.info_total));
    },

    addNetworkLog: function() {
        if (!(this.views.devtools instanceof View_Dev_Tools)) {
            return;
        }

        var network_logs = this.events.flatMap((event) => {
            // Network logs are separated from the rrweb event system:
            return Array.isArray(event.network) ? event.network : [];
        });

        this.views.devtools.updateNetworkLogs(network_logs);
    },

    highlightInactivity: function() {
        this.rrweb_inactivities.forEach(function(inactivity) {
            var seconds = (inactivity.stop - inactivity.start) / 1000;

            var inactivity_timeline = $('<div>')
                .addClass('inactivity tooltip')
                .attr('data-title', 'Inactive: ' + this.getDisplayTime(seconds, true))
                .css({
                    left  : (inactivity.start - this.start_time) / this.total_time * 100 + '%',
                    width : (inactivity.stop - inactivity.start) / this.total_time * 100 + '%'
                })
                .appendTo(this.$el.find('.region-timeline'));
        }.bind(this));
    },

    addTag: function (event, type, tooltip) {
        var goto    = event.timestamp - this.start_time;
        var percent = goto / this.total_time * 100 + '%';

        var timeline_tag = $('<div>')
            .addClass('play-tag')
            .attr('data-type', type)
            .attr('data-goto', goto)
            .css('left', percent)
            .appendTo(this.$el.find('.region-timeline'));

        if (tooltip) {
            timeline_tag.addClass('tooltip').attr('data-title', tooltip);
        }

        var title    = '';
        var selector = '';
        var element  = '';
        var details  = '';

        var event_item = null;

        switch (type) {
            case 'navigation':
                title = 'Navigate';

                if (event.data && event.data.payload && event.data.payload.href) {
                    details = '<div class="font-weight-medium margin-bottom-4">Go to:</div>' +
                              '<div class="box-neutral break-word">' + event.data.payload.href + '</div>';
                }

                break;
            case 'browser_tab':
                if (event.data && event.data.payload && event.data.payload.type) {
                    switch (event.data.payload.type) {
                        case 'page_hidden':
                            title = 'Tab Inactive';
                            break;
                        case 'page_visible':
                            title = 'Tab Active';
                            break;
                    }
                }

                break;
            case 'feedback':
                if (event.data && event.data.payload && event.data.payload.name) {
                    title = event.data.payload.name;
                }

                break;
            case 'rage_click':
                title = 'Rage Click';
                element = event.data.payload.element;
                break;
            case 'custom':
                title = tooltip;

                if (event.data.payload.event) {
                    details = '<div class="box-neutral">' +
                                  Util.jsonHighlight(event.data.payload.event) +
                              '</div>';
                }

                break;
            case 'resize':
                title = 'Resize';
                selector = 'viewport';
                details = '<div class="font-weight-medium margin-bottom-4">Viewport:</div>' +
                          '<div class="box-neutral">' +
                              event.data.width + ' x ' + event.data.height +
                          '</div>';
                break;
            default:
                var node            = this.rrweb_nodes[event.data.id] || null;
                var node_attributes = this.getNodeDisplayName(node);

                title    = type;
                selector = node_attributes.selector;
                element  = node_attributes.element;

                break;
        }

        if (this.show_events) {
            event_item = $('<div>')
                .addClass('event-item')
                .attr('data-type', type)
                .attr('data-goto', goto);

            event_item.html(
                '<div class="event-time">' + this.getDisplayTime((event.timestamp - this.start_time) / 1000) + '</div>' +
                '<div class="event-info">' +
                    '<span class="event-type">' + Util.htmlEntities(title) + '</span>' +
                    '<span class="event-selector">' + Util.htmlEntities(selector) + '</span>' +
                '</div>' +
                (element || details ?
                '<div class="event-details">' +
                    (element ?
                    '<div class="font-weight-medium">Element:</div>' +
                    '<div class="code box-neutral margin-top-4">' + Util.htmlEntities(element) + '</div>' +
                    '<button type="button" class="code-copy"><i class="far fa-copy"></i></button>' : '') +

                    (details || '') +
                '</div>' : '')
            );

            event_item.appendTo(this.$el.find('.region-events'));
        }

        this.rrweb_events[goto] = {
            tag_el   : timeline_tag,
            event_el : event_item
        };

        if (this.event_types_on.indexOf(type) === -1) {
            timeline_tag.hide();

            if (this.show_events) {
                event_item.hide();
            }
        }
    },

    createLogItem: function(info) {
        if (!info) {
            return false;
        }

        var log_item = $('<div>').addClass('log-message');

        var is_json   = info.toString().charAt(0) === '{';
        var is_number = Util.isNumeric(info);

        if (is_json) {
            log_item.html('<span class="json-expand"><i class="fas fa-caret-right"></i></span>' + Util.jsonHighlight(info));
        } else {
            try {
                info = JSON.parse(info).replace(/(?:\r\n|\r|\n){2,}/g, "\n");
            } catch(e) {
            }

            log_item.text(info);
        }

        if (is_json) {
            log_item.attr('data-type', 'json');
        } else if (is_number) {
            log_item.attr('data-type', 'number');
        } else {
            log_item.attr('data-type', 'string');
        }

        return log_item;
    },

    addCustomError: function(event) {
        this.error_total++;

        var log_row = $('<div>')
                        .addClass('log-row')
                        .attr('data-type', 'error');

        var goto = $('<div>')
                    .addClass('goto')
                    .attr('data-goto', event.timestamp - this.start_time)
                    .html('Goto <i class="fas fa-share"></i>')
                    .appendTo(log_row);

        event.data.payload.forEach(function(info) {
            var log_item = this.createLogItem(info.val);

            if (log_item) {
                log_item.addClass('expanded').appendTo(log_row);
            }
        }.bind(this));

        log_row.appendTo(this.$el.find('.console-panel'));
    },

    addConsoleLog: function() {
        if (!(this.views.devtools instanceof View_Dev_Tools)) {
            return;
        }

        var console_logs = this.events
            .filter((item) => {
                return (
                    item.type === Constants.RRWEB_EVENT_TYPE.Plugin &&
                    item.data.plugin &&
                    item.data.plugin.indexOf('rrweb/console') !== -1
                );
            })
            .map((item) => {
                var data = item.data.payload;
                var goto = item.timestamp - this.start_time;

                return {
                    type: data.level,
                    goto: goto,
                    data: data.payload.map((payload) => {
                        var type = 'string';

                        var is_json = payload.toString().charAt(0) === '{';
                        var is_number = Util.isNumeric(payload);

                        if (is_json) {
                            type = 'json';
                        } else if (is_number) {
                            type = 'number';
                        }

                        return {
                            type,
                            val: payload,
                        };
                    }),
                };
            });

        this.views.devtools.updateConsoleLogs(console_logs);
    },

    renderMeta: function(event) {
        var page_url = event.data.href;

        if (page_url.indexOf('https') !== -1) {
            page_url = '<i class="fas fa-lock"></i>' + page_url;
        }

        this.$el.find('.region-url').html(page_url);

        if (event.data.width && event.data.height) {
            this.$el.find('.region-resolution span').text(event.data.width + ' x ' + event.data.height);
        }
    },

    renderTags: function() {
        var content = '';

        var model = Cache.session_recording.get(this.session_recording_id);

        if (model && model.get('tag')) {
            var tags = model.get('tag').split(',');

            tags.slice(0, 3).forEach(function(tag) {
                content += '<span class="text-primary font-weight-medium text-small stop-propagation">#' + Util.htmlEntities(tag) + '</span>';
            });

            if (tags.length > 3) {
                content += '<span class="text-primary font-weight-medium text-small stop-propagation">+' + (tags.length - 3 ) + '</span>';
            }
        }

        this.$el.find('.region-tags').html(content);
    },

    render: function() {
        var content = '';

        content += '<div class="region-address-bar">' +
                        '<div class="region-url-box">' +
                            '<div class="region-url"><div class="loader-placeholder"></div></div>' +
                        '</div>' +
                        '<div class="region-btn-group">' +
                            (this.show_close ?
                            '<button type="button" class="replay-close"><i class="fal fa-times"></i></button>' : '') +

                            (this.show_events ?
                            '<div class="region-events-toggle">' +
                                '<i class="far fa-bullseye-pointer"></i>' +
                                '<span>Events</span>' +
                            '</div>' : '') +
                            (this.show_dev_tools ?
                            '<div class="region-devtools-toggle">' +
                                '<i class="far fa-code"></i>' +
                                '<span>Dev Tools</span>' +
                            '</div>' : '') +
                            '<div class="region-resolution">' +
                                '<i class="far fa-desktop"></i>' +
                                '<span></span>' +
                            '</div>' +
                            (this.show_share ?
                            '<div class="region-share">' +
                                '<button class="tertiary small min replay-share" type="button">Share</button>' +
                            '</div>' : '') +
                            (this.show_tag ?
                            '<div class="region-tag">' +
                                '<button class="tertiary small min replay-tag" type="button">Tag</button>' +
                            '</div>'
                            : '') +
                            '<div class="region-tags"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="region-events"></div>' +
                    '<div class="region-player loader">' +
                        '<div class="loading-msg">Preparing your session replay, please wait...</div>' +
                    '</div>' +
                    '<div class="region-devtools-box">' +
                        '<span class="drag-handle"></span>' +
                    '</div>' +
                    '<div class="region-timeline">' +
                        '<div class="play-progress"></div>' +
                        '<div class="play-progress-circle"></div>' +
                    '</div>' +
                    '<div class="region-controls">' +
                        '<button class="media-control-play" disabled>' + Svg_Icon.media_play + '</button>' +
                        '<button class="media-control-pause" disabled>' + Svg_Icon.media_pause + '</button>' +
                        '<button class="media-control-replay" disabled>' + Svg_Icon.media_replay + '</button>' +
                        '<div class="video-time">' +
                            '<span class="video-time-current">00:00</span>' +
                            ' / ' +
                            '<span class="video-time-total">00:00</span>' +
                        '</div>' +
                        '<button class="media-control-fullscreen">' + Svg_Icon.media_fullscreen + '</button>' +
                        '<button class="media-control-speed" disabled>' +
                            '<span>' + this.speed + '</span><i class="far fa-times"></i>' +
                        '</button>' +
                        '<div class="media-control-settings button-dropdown button-dropdown-up">' +
                            '<button type="button" disabled>' + Svg_Icon.media_settings + '</button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-tag-toggle" style="min-width:220px;">' +
                                    '<li class="nohover cursor-default">' +
                                        '<span><i class="info far fa-fw fa-mouse-pointer"></i> Mouse Click</span>' +
                                        '<button type="button" class="tag-toggle tiny float-right ' + (this.event_types_on.indexOf('click') === -1 ? 'switch-off' : 'switch-on') + '" data-type="click"></button>' +
                                    '</li>' +
                                    '<li class="nohover cursor-default">' +
                                        '<span><i class="info far fa-fw fa-bullseye-pointer"></i> Focus</span>' +
                                        '<button type="button" class="tag-toggle tiny float-right ' + (this.event_types_on.indexOf('focus') === -1 ? 'switch-off' : 'switch-on') + '" data-type="focus"></button>' +
                                    '</li>' +
                                    '<li class="nohover cursor-default">' +
                                        '<span><i class="info far fa-fw fa-compress"></i> Resize</span>' +
                                        '<button type="button" class="tag-toggle tiny float-right ' + (this.event_types_on.indexOf('resize') === -1 ? 'switch-off' : 'switch-on') + '" data-type="resize"></button>' +
                                    '</li>' +
                                    '<li class="nohover cursor-default">' +
                                        '<span><i class="info far fa-fw fa-keyboard"></i> Text Input</span>' +
                                        '<button type="button" class="tag-toggle tiny float-right ' + (this.event_types_on.indexOf('input') === -1 ? 'switch-off' : 'switch-on') + '" data-type="input"></button>' +
                                    '</li>' +
                                    '<li class="nohover cursor-default">' +
                                        '<span><i class="info far fa-fw fa-arrows-retweet"></i> Navigation</span>' +
                                        '<button type="button" class="tag-toggle tiny float-right ' + (this.event_types_on.indexOf('navigation') === -1 ? 'switch-off' : 'switch-on') + '" data-type="navigation"></button>' +
                                    '</li>' +
                                    '<li class="nohover cursor-default">' +
                                        '<span><i class="info far fa-fw fa-window-restore"></i> Browser Tab</span>' +
                                        '<button type="button" class="tag-toggle tiny float-right ' + (this.event_types_on.indexOf('browser_tab') === -1 ? 'switch-off' : 'switch-on') + '" data-type="browser_tab"></button>' +
                                    '</li>' +
                                    '<li class="nohover cursor-default">' +
                                        '<span><i class="info far fa-fw fa-bolt"></i> Rage Clicks</span>' +
                                        '<button type="button" class="tag-toggle tiny float-right ' + (this.event_types_on.indexOf('rage_click') === -1 ? 'switch-off' : 'switch-on') + '" data-type="rage_click"></button>' +
                                    '</li>' +
                                    '<li class="nohover cursor-default">' +
                                        '<span><i class="info far fa-fw fa-tag"></i> Custom</span>' +
                                        '<button type="button" class="tag-toggle tiny float-right ' + (this.event_types_on.indexOf('custom') === -1 ? 'switch-off' : 'switch-on') + '" data-type="custom"></button>' +
                                    '</li>' +
                                    //'<li class="separator"></li>' +
                                    //'<li class="nohover cursor-default">' +
                                    //    '<span><i class="info far fa-fw fa-tilde"></i> Mouse Tail</span>' +
                                    //    '<button type="button" class="mouse-tail-toggle tiny float-right ' + (this.show_mouse_tail ? 'switch-on' : 'switch-off') + '"></button>' +
                                    //'</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                        '<div class="media-control-inactivity">' +
                            '<span>Skip inactivity</span>' +
                            '<button class="skip-inactivity small ' + (this.skip_inactive ? 'switch-on' : 'switch-off') + '" disabled></button>' +
                        '</div>' +
                    '</div>';

        this.$el.html(content);

        if (this.auto_load) {
            this.load();
        }

        this.renderTags();

        if (this.views.devtools instanceof View_Dev_Tools) {
            this.views.devtools.render().$el.appendTo(this.$el.find('.region-devtools-box'));
        }

        return this;
    }
});

export default Session_Player;
